import classes from "./HandWrittenLogo.module.css";
import React, { useState } from "react";
import { Fragment } from "react";
import { useEffect } from "react";

function HandWrittenLogo() {
  const [count, setCount] = useState(0);
  const donearray = [];
  const [doneArray, setDoneArray] = useState(donearray);

  useEffect(() => {
    let element = document.getElementById(array[count]);

    element.addEventListener("animationend", () => {
      if (count < array.length - 1) {
        setDoneArray((prevArray) => [...prevArray, array[count]]);

        setCount(count + 1);
      }
    });
  }, [count]);

  const array = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
  ];

  function ThisCheck(letter) {
    if (letter === array[count]) {
      return true;
    } else {
      return false;
    }
  }

  function CompletedCheck(letter) {
    if (doneArray.includes(letter)) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Fragment>
      <svg
        className={classes.logo}
        width="440"
        height="74"
        viewBox="0 0 440 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="a"
          className={`${ThisCheck("a") ? classes.animating : ""} ${
            CompletedCheck("a") ? classes.after : classes.before
          } ${classes.a}`}
          d="M27.93 23.7099C25.29 32.1499 23.4 40.8199 22.26 49.5899C21.85 52.7299 21.93 56.6499 24.72 58.1299C27.3 59.4999 30.4 57.7799 32.72 55.9899C39.29 50.9399 45.18 44.8099 49.01 37.4599C51.82 32.0599 53.3 24.9899 49.55 20.1899C46.42 16.1899 40.72 15.2099 35.67 15.7399C23.16 17.0399 11.83 26.2899 8.04999 38.2899"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="b"
          className={`${ThisCheck("b") ? classes.animating : ""} ${
            CompletedCheck("b") ? classes.after : classes.before
          }  ${classes.b}`}
          d="M73.2 23.78C68.95 23.06 64.97 26.01 62.11 29.23C57.87 33.99 54.76 39.75 53.1 45.91C52.57 47.88 52.18 49.98 52.69 51.96C53.2 53.94 54.82 55.76 56.86 55.91C57.98 55.99 59.07 55.57 60.1 55.11C70.28 50.54 77.95 40.71 79.74 29.67C80.02 27.95 79.57 26.14 78.35 24.9C75.51 22.01 71.49 24.45 69.35 27.27C66.61 30.87 65.02 35.34 64.9 39.87C64.87 41.07 65.12 42.29 65.8 43.27C67.96 46.35 72.17 44.94 75.07 43.1C81.03 39.34 86.21 34.37 90.2 28.57C86.47 35.34 83.12 42.33 80.19 49.49C79.69 50.71 80.16 52.19 81.37 52.72C82.66 53.29 83.72 52.27 84.53 51.35C89.32 45.94 94.06 40.49 98.76 34.99H98.86C97.09 40.68 95.19 46.76 95.75 52.66C95.81 53.28 96.56 53.57 97.01 53.14C101.78 48.55 106.15 43.54 110.04 38.18H110.11C109.88 41.85 109.53 45.63 109.37 49.24C109.3 50.73 109.85 52.23 110.99 53.19C113.26 55.12 115.97 53.49 117.94 51.84C123.2 47.44 127.75 42.18 131.36 36.35C129.75 40.28 128.49 44.35 127.59 48.49C127.37 49.52 127.16 50.6 127.45 51.61C127.93 53.34 129.77 54.44 131.57 54.56C133.37 54.69 135.12 54.03 136.75 53.27C140.59 51.47 144.12 49 147.13 46"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />

        <path
          id="c"
          className={`${CompletedCheck("c") ? classes.after : classes.before} ${
            ThisCheck("c") ? classes.animating : ""
          } ${classes.c}`}
          d="M190.43 7.71997C181.96 26.33 177.75 46.86 178.23 67.3"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="d"
          className={`${CompletedCheck("d") ? classes.after : classes.before} ${
            ThisCheck("d") ? classes.animating : ""
          } ${classes.d}`}
          d="M203.82 15.15C186.57 19.93 170.91 30.28 159.76 44.29"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="e"
          className={`${CompletedCheck("e") ? classes.after : classes.before} ${
            ThisCheck("e") ? classes.animating : ""
          } ${classes.e}`}
          d="M201.77 30.64C189.4 35.71 178.03 43.19 168.46 52.53"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="f"
          className={`${CompletedCheck("f") ? classes.after : classes.before} ${
            ThisCheck("f") ? classes.animating : ""
          } ${classes.f}`}
          d="M190.67 43.51C194.67 47.32 200.8 48.55 206.12 47.04C211.44 45.53 215.88 41.51 218.37 36.57C219.09 35.15 219.67 33.6 219.59 32.01C219.51 30.42 218.65 28.79 217.17 28.19C215.56 27.53 213.71 28.24 212.25 29.19C208.17 31.85 205.61 36.29 203.84 40.83C202.9 43.24 202.14 45.8 202.46 48.37C202.78 50.94 204.42 53.48 206.91 54.16C209.46 54.86 212.08 53.51 214.38 52.21C216.49 51.02 220.05 48.78 223.42 45.83"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="g"
          className={`${CompletedCheck("g") ? classes.after : classes.before} ${
            ThisCheck("g") ? classes.animating : ""
          } ${classes.g}`}
          d="M244.26 34.9699C244.23 32.4699 243.32 28.9599 239.19 27.9899C237.19 27.5199 233.82 28.5599 231.13 31.1899C226.82 35.4099 223.25 42.3699 222.93 49.5099C222.82 52.0599 224.47 54.0799 226.59 54.5599C230.35 55.4099 233.56 53.5499 236.17 50.7099C238.54 48.1299 240.39 45.5099 242.32 40.6999"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="h"
          className={`${CompletedCheck("h") ? classes.after : classes.before} ${
            ThisCheck("h") ? classes.animating : ""
          } ${classes.h}`}
          d="M252.74 10.85C250.24 17.95 247.73 25.06 245.23 32.16C243.41 37.33 241.07 42.53 241.32 48.01C241.55 52.98 246.13 52.93 247.87 52.52C256.15 50.58 262.25 43.48 266.22 35.96C267.08 34.34 267.88 32.59 267.8 30.76C267.72 28.93 266.49 27.02 264.67 26.79C263.3 26.62 262 27.4 260.93 28.26C255.25 32.86 252.76 41.04 254.93 48.02C255.26 49.09 255.7 50.15 256.47 50.96C258.79 53.46 262.94 52.72 265.99 51.21C268.75 49.84 271.63 47.45 273.2 45.76C276.77 41.92 282.4 33.61 284.44 27.94C284.94 26.55 285.4 25.09 285.25 23.62C285.1 22.15 284.21 20.65 282.79 20.24C281.59 19.89 280.3 20.38 279.25 21.07C276.56 22.86 274.95 26.16 275.2 29.39C275.45 32.61 277.56 35.63 280.49 36.98C285.08 39.08 290.41 37.12 295.06 35.16L295.13 35.33C291.41 39.98 287.45 44.79 286.06 50.57C285.88 51.31 285.75 52.12 286.04 52.83C286.69 54.42 288.89 54.54 290.57 54.16C292.72 53.67 297.13 52.52 301.47 48.26"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="i"
          className={`${CompletedCheck("i") ? classes.after : classes.before} ${
            ThisCheck("i") ? classes.animating : ""
          } ${classes.i}`}
          d="M311.88 27.7299C304.96 31.8799 301.67 40.4799 301.44 48.5399C301.41 49.6199 301.47 50.7499 302.02 51.6799C302.89 53.1299 304.81 53.6799 306.47 53.3699C308.13 53.0599 309.57 52.0499 310.86 50.9499C316.45 46.1899 320.15 39.2599 321 31.9599C321.16 30.5999 321.18 29.0699 320.29 28.0199C319.38 26.9299 317.71 26.7099 316.37 27.1999C315.04 27.6899 314 28.7699 313.19 29.9399C310.45 33.8799 309.9 39.2599 311.78 43.6699C312.2 44.6599 312.76 45.6299 313.63 46.2599C314.68 47.0299 316.05 47.2099 317.35 47.1799C324.81 47.0099 331.02 40.7399 333.52 33.7099"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="j"
          className={`${CompletedCheck("j") ? classes.after : classes.before} ${
            ThisCheck("j") ? classes.animating : ""
          } ${classes.j}`}
          d="M335.37 28.5699C333.73 33.0699 332.09 37.5699 330.46 42.0699C329.25 45.3799 328.03 48.8599 328.49 52.3499C328.55 52.8399 328.67 53.3599 329 53.7199C329.95 54.7399 331.62 53.8199 332.62 52.8499C339.16 46.4399 343.32 37.7299 344.55 28.6499C342.21 36.1399 340.99 43.9799 340.94 51.8299C340.93 53.4199 341.06 55.2199 342.25 56.2699C343.39 57.2699 345.18 57.2199 346.52 56.4999C347.86 55.7799 348.82 54.5399 349.65 53.2599C354.41 45.9499 355.85 36.5599 353.52 28.1599C354.18 30.9599 357.17 32.7299 360.04 32.7999C362.91 32.8699 367.41 31.1899 369.85 29.6799"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="k"
          className={`${CompletedCheck("k") ? classes.after : classes.before} ${
            ThisCheck("k") ? classes.animating : ""
          } ${classes.k}`}
          d="M371.1 27.37C367.24 34.21 363.88 41.54 362.08 49.18C361.77 50.5 361.63 52.66 361.95 53.98C362.99 58.22 367.26 56.54 369.11 55.19C371.27 53.63 375.18 50.2 378.58 46.21"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="l"
          className={`${CompletedCheck("l") ? classes.after : classes.before} ${
            ThisCheck("l") ? classes.animating : ""
          } ${classes.l}`}
          d="M395.7 32.4699C395.46 30.3999 394.03 27.8599 391.71 27.6599C389.76 27.4899 388.01 28.8399 386.59 30.1799C382.15 34.3699 379.26 40.1599 378.58 46.2199C378.29 48.8399 378.7 52.0199 381.06 53.1999C382.02 53.6799 383.15 53.7199 384.21 53.5899C388.55 53.0599 392.08 49.9699 395.31 47.0199"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="m"
          className={`${CompletedCheck("m") ? classes.after : classes.before} ${
            ThisCheck("m") ? classes.animating : ""
          } ${classes.m}`}
          d="M402.3 22.34C401.72 26.51 405.38 30.32 409.45 31.44C413.51 32.55 417.83 31.67 421.95 30.78L422.01 30.89C412.58 37.5 404.03 45.69 397.25 55C398.71 53.31 401.22 52.93 403.41 53.36C405.59 53.79 407.58 54.89 409.62 55.77C413.67 57.5 418.21 58.34 422.52 57.45C426.83 56.55 430.86 53.74 432.56 49.67"
          strokeWidth="5"
          strokeMiterlimit="10"
          pathLength="1"
        />
        <path
          id="n"
          className={`${
            CompletedCheck("n") ? classes.dotafter : classes.dotbefore
          } ${ThisCheck("n") ? classes.dotanimating : ""} ${classes.n}`}
          d="M374.735 23.4488C376.239 23.4488 377.471 22.2318 377.471 20.7244C377.471 19.2265 376.249 18 374.735 18C373.231 18 372 19.2171 372 20.7244C372.009 22.2224 373.231 23.4488 374.735 23.4488Z"
        />
        <path
          id="o"
          className={`${
            CompletedCheck("o") ? classes.dotafter : classes.dotbefore
          } ${ThisCheck("o") ? classes.dotanimating : ""} ${classes.o}`}
          d="M137.735 30.4488C139.239 30.4488 140.471 29.2318 140.471 27.7244C140.471 26.2265 139.249 25 137.735 25C136.231 25 135 26.2171 135 27.7244C135.009 29.2224 136.231 30.4488 137.735 30.4488Z"
        />
      </svg>
    </Fragment>
  );
}

export default HandWrittenLogo;
